import { useEffect } from "react";
import Layout from "./Layout";
import { useCartStore } from "../store/cartStore";
import { getGuestUserId } from "../utils/guestUser";
import { FaTrash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

export default function Cart() {
  const isLoading = useCartStore((s) => s.isLoading);
  const cart = useCartStore((s) => s.cart);
  const loadCart = useCartStore((s) => s.loadCart);
  const updateQty = useCartStore((s) => s.updateQty);
  const removeItem = useCartStore((s) => s.removeItem);
  const userId = getGuestUserId();
  const navigate = useNavigate();

  useEffect(() => {
    loadCart();
  }, [loadCart]);

  const totalPrice = cart.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0,
  );

  return (
    <Layout>
      <section className="px-6 lg:px-12 md:px-12 sm:px-12 xs:px-10 xxs:px-8 py-6 md:py-10 lg:py-10 sm:py-10 xs:py-8 xxs:py-6 max-w-5xl mx-auto">
        <h1 className="text-4xl font-serif text-light_primary mb-6">
          Your Cart
        </h1>
        {isLoading ? (
          <p className="text-black">Loading your cart...</p>
        ) : cart.length === 0 ? (
          <p className="text-black">Your cart is empty.</p>
        ) : (
          <div className="flex flex-col gap-6">
            {cart.map((item, idx) => (
              <div
                key={idx}
                className="bg-footer_clr rounded-lg p-4 text-black
                grid gap-4
                grid-cols-3
                sm:grid-cols-[60px_1fr_120px_120px_80px_40px]
                items-center"
              >
                <img
                  src={item.image[0]}
                  alt={item.title}
                  className="w-10 h-10 object-cover rounded"
                />
                <Link
                  to={`/product/${item.productId}`}
                  className="text-lg font-medium  hover:underline transition"
                >
                  {item.title}
                </Link>
                <span className=" font-medium">
                  {item.quantity} x ₹{item.price}
                </span>

                {/* Quantity Controls */}
                <div className="flex items-center gap-2 mt-4 sm:mt-0">
                  <button
                    onClick={() => updateQty(item.productId, -1)}
                    className="bg-white text-black px-3 py-1 rounded"
                  >
                    -
                  </button>
                  <span className="text-black font-semibold">
                    {item.quantity}
                  </span>
                  <button
                    onClick={() => updateQty(item.productId, +1)}
                    className="bg-white text-black px-3 py-1 rounded"
                  >
                    +
                  </button>
                </div>

                <span className="text-black font-semibold hidden sm:block">
                  ₹{item.quantity * item.price}
                </span>

                {/* Delete Button */}
                <button
                  onClick={() => removeItem(item.productId)}
                  className="text-red-400 hover:text-red-500 transition"
                  title="Remove item"
                >
                  <FaTrash className="w-5 h-5" />
                </button>
              </div>
            ))}

            <div className="flex justify-between mt-4 text-xl font-semibold text-gray-100">
              <span>Total :</span>
              <span>₹{totalPrice.toFixed(2)}</span>
            </div>

            <a
              href="/checkout"
              className="mt-4 text-center bg-primary text-white px-6 py-3 rounded-lg transition w-full sm:w-auto"
            >
              Proceed to Checkout
            </a>
          </div>
        )}
      </section>
    </Layout>
  );
}
